import React, { useCallback } from "react";

import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Checkbox, { CheckboxChangeEvent } from "antd/es/checkbox";
import Space from "antd/es/space";
import Tooltip from "antd/es/tooltip";

import { useConfigProvider } from "../../../../ConfigProvider";

import styles from "./UnsubscribeLink.module.scss";

interface UnsubscribeLinkProps {
  onUnsubscribeLinkIncludedChange: (value: boolean) => void;
  unsubscribeLinkIncluded: boolean;
}

const UnsubscribeLink = ({
  onUnsubscribeLinkIncludedChange,
  unsubscribeLinkIncluded,
}: UnsubscribeLinkProps) => {
  const configProvider = useConfigProvider();

  const handleCheckboxChange = useCallback(
    (e: CheckboxChangeEvent) => {
      onUnsubscribeLinkIncludedChange(e.target.checked);
    },
    [onUnsubscribeLinkIncludedChange]
  );

  return (
    <div>
      <Checkbox checked={unsubscribeLinkIncluded} onChange={handleCheckboxChange}>
        <Space size="small">
          {configProvider.formatMessage("ui.emailBody.emailUnsubscribeLink.checkboxLabel")}
          <Tooltip
            title={configProvider.formatMessage(
              "ui.emailBody.emailUnsubscribeLink.checkboxTooltip"
            )}
          >
            <FontAwesomeIcon className={styles.infoIcon} icon={faInfoCircle} />
          </Tooltip>
        </Space>
      </Checkbox>
    </div>
  );
};

export default UnsubscribeLink;
